export function indexAcceptedChangesForPreview(acceptedChanges, tasks = []) {
    const changesByType = {}
    const taskIdsBySequence = buildTaskIdsBySequence(tasks)

    for (const change of Array.isArray(acceptedChanges) ? acceptedChanges : []) {
        for (const key of buildPreviewKeys(change, taskIdsBySequence)) {
            changesByType[key] = change
        }
    }

    return changesByType
}

export function buildPreviewTasks(resolution, changesByType) {
    const tasks = resolution?.tasks ?? []
    const result = []
    let position = 1

    for (const task of tasks) {
        const taskKey = `${task?.id ?? ""}`
        const removeChange = changesByType[`remove_task:${taskKey}`] ?? null

        if (removeChange) {
            result.push({ ...task, position, removed: true, hasChange: true })
            position++
            continue
        }

        const contentChange = changesByType[`task_content:${taskKey}`] ?? null
        const noteChange = changesByType[`task_note:${taskKey}`] ?? null
        const titleChange = changesByType[`task_title:${taskKey}`] ?? null
        const frequencyChange = changesByType[`task_frequency:${taskKey}`] ?? null

        result.push({
            ...task,
            position,
            hasChange: !!(contentChange || noteChange || titleChange || frequencyChange),
            contentChange,
            noteChange,
            titleChange,
            frequencyChange,
            removed: false,
            added: false,
        })
        position++
    }

    for (const change of Object.values(changesByType)) {
        if (change.changeType === "add_task" && (change.proposedTask || change.newText)) {
            try {
                const newTask =
                    change.proposedTask ||
                    (typeof change.newText === "string" ? JSON.parse(change.newText) : change.newText)
                result.push({ ...newTask, position, added: true, hasChange: true })
                position++
            } catch {
                // Malformed add_task — skip
            }
        }
    }

    return result
}

function buildPreviewKeys(change, taskIdsBySequence) {
    if (requiresTaskKey(change?.changeType)) {
        return buildTaskPreviewKeys(change, taskIdsBySequence)
    }

    return change?.changeType ? [change.changeType] : []
}

function buildTaskPreviewKeys(change, taskIdsBySequence) {
    const taskIds = collectPreviewTaskIds(change, taskIdsBySequence)
    return taskIds.map((taskId) => `${change.changeType}:${taskId}`)
}

function collectPreviewTaskIds(change, taskIdsBySequence) {
    const taskIds = new Set()
    addPreviewTaskId(taskIds, change?.resolvedTaskId)
    addPreviewTaskId(taskIds, change?.taskId)

    const taskNumber = Number(change?.taskId)
    if (Number.isInteger(taskNumber)) {
        addPreviewTaskId(taskIds, taskIdsBySequence.get(taskNumber))
    }

    return [...taskIds]
}

function buildTaskIdsBySequence(tasks) {
    const taskIdsBySequence = new Map()
    let counter = 0

    for (const task of Array.isArray(tasks) ? tasks : []) {
        if (task?.isHeader) continue
        counter++
        addPreviewTaskId(taskIdsBySequence, counter, task?.id)
    }

    return taskIdsBySequence
}

function requiresTaskKey(changeType) {
    return `${changeType || ""}`.startsWith("task_") || changeType === "remove_task"
}

function addPreviewTaskId(collection, keyOrValue, maybeValue) {
    const value = maybeValue === undefined ? keyOrValue : maybeValue
    if (value === null || value === undefined || value === "") return

    const normalized = `${value}`
    if (collection instanceof Map) {
        collection.set(keyOrValue, normalized)
        return
    }

    collection.add(normalized)
}
